module.exports = __webpack_public_path__ + "img/devs-choice.74a5b12.png";